export class Appeal {
  // for all
  public type: string;
  public file: any;
  public phone: string;
  public email: string;
  public name: string;
  public message: string;
  public street: string;
  public house: string;
  public building: string;
  public flat: string;
  public postcode: string;
  public city: string;
  public status: string;

  // for legal
  public district: string;
  public region: string;
  public legal_name: string;
  public legal_position: string;

  // other
  public updated_at?: string;
  public created_at?: string;
  public comment?: string;
  public id?: number;
  public request_files?: any[];
  public response_file?: any;
  public date_of_visit: string;
  public date?: string;
  public time?: string;

  public get statusTitle() {
    return this.status
      ? 'APPEAL_' + this.status.toUpperCase()
      : 'NO_APPEAL_STATUS';
  }

  constructor(item?) {
    this.update(item);
  }

  public update(el): void {
    if (el) {
      Object.assign(this, el);
    }
  }
}
